"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = capitalize;
/**
 * @description Capitalizes the given string
 * @summary
 * Ensures, that the first character of a given string is uppercase.
 * This method is inspired by ruby's `capitalize` and PHP's `ucfirst`.
 *
 * NOTE: This method will not trim the input string, so if your string starts with whitespace,
 *       then nothing changes.
 *
 * @example
 * import { capitalize } from '@nimius/string-utility'
 *
 * capitalize('test');
 * // => 'Test'
 *
 * capitalize('test string');
 * // => 'Test string'
 *
 * capitalize(' test');
 * // => ' test'
 *
 * @param {string} string - The string that should be capitalized.
 * @returns {string} - The capitalized string.
 */
function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nimius/string-utility/src/capitalize.js
// module id = 36
// module chunks = 0 2